import $ from 'jquery';

function handleerror(xhr, status, error) {
  console.log("Ajax Failure");
  console.log(xhr.responseText);
  console.log(status);
  console.log(error);
}

function ajaxWrapper(type, url, data, returnFunc, failFunc){
    if (type === "POST") {
        data["csrfmiddlewaretoken"] = window.secretReactVars["csrfmiddlewaretoken"];
    }

    let auth_token = '';
    let beforeSend = null;

    if (localStorage.getItem('token')) {
        auth_token = 'Bearer ' + localStorage.getItem('token');
        beforeSend = function(request) {
            request.setRequestHeader('Authorization', auth_token);
        };
    }

    return $.ajax({
        type: type,
        url: url,
        beforeSend: beforeSend,
        data: data,
        // Use the success hook instead of an exact 200 handler because create
        // endpoints correctly return 201 and must participate in token retries.
        success: function (value) {
            if (typeof value === "object" && "redirect" in value) {
                window.location =
                    value.redirect + "?redirect=" + window.secretReactVars.BASE_URL;
                return;
            }

            if (typeof returnFunc === "function") {
                returnFunc(value);
            } else {
                console.warn("ajaxWrapper: returnFunc is not a function", returnFunc);
            }
        },
        error: function (xhr, status, error) {
            // 400/401/404 retain their legacy status handlers below. Forward
            // other final API errors so callers can show the server message.
            if ([400, 401, 404].indexOf(xhr.status) === -1) {
                if (typeof failFunc === "function") {
                    failFunc(xhr);
                } else {
                    handleerror(xhr, status, error);
                }
            }
        },
        statusCode: {
            400: function (xhr) {
                if (typeof failFunc === "function") {
                    failFunc(xhr);
                } else if (typeof returnFunc === "function") {
                    // Preserve the legacy callback contract for older callers
                    // while forwarding the backend's useful validation message.
                    returnFunc(xhr.responseJSON || { error: "Bad Request" });
                }
            },

            401: function () {
                refreshToken(type, url, data, returnFunc, failFunc);
            },

            404: function (xhr) {
                if (typeof failFunc === "function") {
                    failFunc(xhr);
                } else {
                    console.log("Error, 404");
                }
            },
        },
    });
}

function refreshToken(type, url, data, returnFunc, failFunc){
    let refreshData = {};
    refreshData["csrfmiddlewaretoken"] = window.secretReactVars["csrfmiddlewaretoken"];

    if (localStorage.getItem('refresh_token')) {
        refreshData['refresh'] = localStorage.getItem('refresh_token');
    }

    $.ajax({
        type: 'POST',
        url: '/users/token/refresh/',
        data: refreshData,
        statusCode: {
            401: function () {
                console.log('Refresh Token Expired');
                localStorage.removeItem('token');
                localStorage.removeItem('refresh_token');
                window.location.href = '/login/';
            }
        },
        success: function (value) {
            localStorage.setItem('token', value.access);
            // Retry with both original callbacks so the page observes only the
            // final outcome, not the initial expired-access-token response.
            ajaxWrapper(type, url, data, returnFunc, failFunc);
        },
        error: function (xhr, status, error) {
            handleerror(xhr, status, error);
            localStorage.removeItem('token');
            localStorage.removeItem('refresh_token');
            window.location.href = '/login/';
        }
    });
}

export default ajaxWrapper;
